import { Alert as AntdAlert, AlertProps as AntdAlertProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";
import {
  InfoIcon,
  InfoMdIcon,
  SuccessIcon,
  SuccessMdIcon,
  WarningIcon,
  WarningMdIcon,
  AlertIcon,
  AlertMdIcon,
} from "@/base/static/index";
export interface AlertProps extends AntdAlertProps {}

export const alertPrefixCls = `${CMP_PREFIX}-alert`;

export const Alert = ({ icon, type, ...props }: AlertProps) => {
  const getIcon = (type: any): any => {
    switch (type) {
      case "error":
        return props.description ? <AlertMdIcon /> : <AlertIcon />;
      case "success":
        return props.description ? <SuccessMdIcon /> : <SuccessIcon />;
      case "info":
        return props.description ? <InfoMdIcon /> : <InfoIcon />;
      case "warning":
        return props.description ? <WarningMdIcon /> : <WarningIcon />;
    }
  };

  return <AntdAlert type={type} icon={icon || getIcon(type)} {...props} />;
};
